import { useMonthlyTask } from '@app/components/Calendars/components/MonthGrid/components/MonthlyTask/hooks/useMonthlyTask';

export { useMonthlyTask };
